import React from 'react';

type PropsType = {
  size?: number;
  className?: string;
};

function Spinner({ size = 28, className = '' }: PropsType) {
  return (
    <svg
      role='status'
      aria-label='Loading'
      width={size}
      height={size}
      viewBox='0 0 50 50'
      fill='none'
      className={`animate-spin ${className}`}
    >
      <circle cx='25' cy='25' r='20' stroke='currentColor' strokeWidth='5' opacity='0.18' />
      <path
        d='M45 25a20 20 0 0 0-20-20'
        stroke='currentColor'
        strokeWidth='5'
        strokeLinecap='round'
      />
    </svg>
  );
}

export default Spinner;
